import MixApplyPage from 'pages/MixApplyPage';
import {
    CA_HAPPY_PATH_SCENARIO,
    DEFAULT_SCENARIO,
    NY_BLOCKED_SCENARIO,
    OR_COMING_SOON_SCENARIO
} from 'pages/MixApplyPage/scenarios.mockData';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const SCENARIOS_BY_VARIANT = {
    'ca-happy': CA_HAPPY_PATH_SCENARIO,
    'ny-blocked': NY_BLOCKED_SCENARIO,
    'or-coming-soon': OR_COMING_SOON_SCENARIO
};

const MixApplyPreview: FunctionComponent<Props> = ({ testId = TEST_ID, variant }) => {
    const scenario =
        variant && variant in SCENARIOS_BY_VARIANT
            ? SCENARIOS_BY_VARIANT[variant as keyof typeof SCENARIOS_BY_VARIANT]
            : DEFAULT_SCENARIO;

    return (
        <MixApplyPage
            overrideApplication={scenario.application}
            overrideMixRecipe={scenario.mixRecipe}
            overrideTankState={scenario.tankState}
            overrideWeather={scenario.weather ?? DEFAULT_SCENARIO.weather!}
            testId={testId}
        />
    );
};

export default MixApplyPreview;
